module.exports = __webpack_public_path__ + "static/seo-7728bd349727746ff0f430bcd9b28a4f.png";